import { render, staticRenderFns } from "./k-status-text.vue?vue&type=template&id=16c49767&"
import script from "./k-status-text.vue?vue&type=script&lang=ts&"
export * from "./k-status-text.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports